export default __webpack_public_path__ + "static/media/icon-po-arrow.9d45749f.svg";